/* AFORDA multi-image gallery — uses Dawn's native active-media and thumbnail selection. */
(() => {
  const ROOT = '.aforda-pdp--multi-media media-gallery';
  const allSlides = (gallery) =>
    [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > li[data-media-id]')].filter(
      (slide) => !slide.classList.contains('product__media-item--variant')
    );

  function updateCounter(gallery, fromSlide) {
    const slides = allSlides(gallery);
    const active = fromSlide || slides.find((slide) => slide.classList.contains('is-active'));
    const index = Math.max(0, slides.indexOf(active));
    const controls = gallery.querySelector('[data-aforda-gallery-controls]');
    if (!controls) return;
    const current = controls.querySelector('[data-aforda-gallery-current]');
    const total = controls.querySelector('[data-aforda-gallery-total]');
    if (current) current.textContent = String(index + 1);
    if (total) total.textContent = String(slides.length);
  }

  function attach(gallery) {
    if (gallery.dataset.afordaControlsReady) return;
    gallery.dataset.afordaControlsReady = 'true';
    const list = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!list) return;
    const watcher = new MutationObserver(() => updateCounter(gallery));
    watcher.observe(list, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    gallery.addEventListener('slideChanged', (event) => updateCounter(gallery, event.detail?.currentElement));
    updateCounter(gallery);
  }

  function initialize() {
    document.querySelectorAll(ROOT).forEach(attach);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-aforda-gallery-direction]');
    if (button) {
      const gallery = button.closest('media-gallery');
      if (!gallery) return;
      attach(gallery);
      const slides = allSlides(gallery);
      if (slides.length < 2) return;
      const activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      const step = Number(button.dataset.afordaGalleryDirection) || 1;
      const next = slides[(activeIndex + step + slides.length) % slides.length];
      if (!next) return;
      event.preventDefault();
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(next.dataset.mediaId, false);
      } else {
        gallery.querySelector('[data-target="' + next.dataset.mediaId + '"] button')?.click();
      }
      updateCounter(gallery, next);
      return;
    }
    const thumb = event.target.closest?.('.aforda-pdp--multi-media .thumbnail-list__item');
    if (thumb) {
      const gallery = thumb.closest('media-gallery');
      if (gallery) requestAnimationFrame(() => updateCounter(gallery));
    }
  });

  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
